export default __webpack_public_path__ + "static/media/Background_00036.ebc5ee48.png";